'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = require('../../lib/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Switch__hiddenInput___3fGAk',
  'wrapper': 'Switch__wrapper___5CfDV',
  'label': 'Switch__label___2_a4i',
  'switch': 'Switch__switch___1A_eG',
  'slider': 'Switch__slider___3pYya',
  'isActive': 'Switch__isActive___13rcF',
  'dot': 'Switch__dot___88yY4',
  'sliderTextOn': 'Switch__sliderTextOn___i5xz3',
  'sliderTextOff': 'Switch__sliderTextOff___1Kc8h',
  'isChecked': 'Switch__isChecked___373wR'
};

var DefaultSwitch = (0, _mergeThemeHoc2.default)(style)(_Switch2.default);
DefaultSwitch.displayName = 'DefaultSwitch';
exports.default = DefaultSwitch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Switch/index.js
// module id = ./node_modules/dibs-elements/dist/Switch/index.js
// module chunks = 4